import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes.js'
import { ability } from 'src/boot/casl.js'
import { user } from 'src/boot/userData.js'
import { cleanToken } from '@nitra/components/njs/token.js'

Vue.use(VueRouter)

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

/**
 *
 */
export default function (/* { store, ssrContext } */) {
  const Router = new VueRouter({
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes,

    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE
  })

  Router.beforeEach(async (to, _from, next) => {
    // Якщо сторінки входу
    // виконуємо без перевірок
    if (['/login', '/code', '/logout'].includes(to.path)) {
      return next()
    }

    // перевіряємо токен що він ще не закінчився
    if (!user.exp || !ability || user.exp * 1000 < Date.now()) {
      // Записуємо поточний урл в session storage
      // щоб потім на нього повернути після логіну
      sessionStorage.setItem('url-before-logout', to.path)

      // cleanToken()
      return next('/login')
    }

    // Якщо хоча б один роут не дозволено
    // забороняємо перехід
    if (to.matched.some(record => record.meta.roles && !ability.can('read', record.meta.roles))) {
      alert(`У вас немає прав для переходу на цю сторінку (${to.path}), будь ласка зверніться до адміністратора`)
      next('/logout')
    } else {
      next()
    }
  })

  return Router
}
